import AwesomeLoaders from "../../../../pages/docs/code/rug";
import { DonateButton, StyledParent } from "../../../../pages/docs/code/donate";
import { Profile } from "../../../../pages/docs/code/profile";
import ProfileImage from "../../../../images/profile.png";
import YoutubeImage from "../../../../images/youtube.png";
import LinkedinImage from "../../../../images/linkedin.png";
import GithubImage from "../../../../images/github.png";
import InstagramImage from "../../../../images/instagram.png";
import FacebookImage from "../../../../images/facebook.png";
import TwitterImage from "../../../../images/twitter.jpg";
import GmailImage from "../../../../images/gmail.png";
import * as React from 'react';
export default {
  AwesomeLoaders,
  DonateButton,
  StyledParent,
  Profile,
  ProfileImage,
  YoutubeImage,
  LinkedinImage,
  GithubImage,
  InstagramImage,
  FacebookImage,
  TwitterImage,
  GmailImage,
  React
};